module.exports = __webpack_public_path__ + "static/super-pumped-the-battle-for-uber-ad3f594271e0c900a161d3c1e63f1ffa.jpg";